import helix from '../assets/helix2.svg';
import ArrowRight from '../assets/arrow-right.svg';
import './Cases.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import i18n from '../i18n';


export default function Cases() {
    const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
    const { t } = useTranslation();
    return(
        <section className='case-section' id='case-section'>
            <div className='case-title'>
                <div className='cases-title-left'>
                    <div className='cases-title-text'>
                        <h1>
                            <Trans
                                i18nKey="$Header3"
                                components={{ highlight: <span className='cases-title-gr1' /> }}
                            />
                        </h1>
                        <p>
                            {t('$Subheader6')}
                        </p>
                    </div>
                </div>
                <div className='cases-title-right'>
                    <img src={helix} alt='helix'/>
                </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', gap:'72px'}}>
            <div className='stat-row'>
                <div className='case-stat-content'>
                    <p className='case-stat-title'>
                        {t('$BC_1')}
                    </p>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '24px', marginRight: '64px'}}> 
                    <div style={{display: 'flex', flexDirection: 'column', gap: '24px'}}>
                    <label>
                        <p>
                            690
                        </p>
                        {t('$BC_1.1_units')}
                    </label>
                    <label>
                        <p>
                            74%
                        </p>
                        {t('$BC_1.2_units')}
                    </label>
                    </div>
                    <div>
                        <label>
                            <p>
                                5-6
                            </p>
                            {t('$BC_1.3_units')}
                        </label>
                    </div>
                    </div>
                </div>
                <div className='case-stat-descr'>
                    <h1>
                        {t('$BC_1_name')}
                     </h1>
                     <p>
                         {t('$BC_1_disc')}
                     </p>
                     <Link to={`/money-article`}>
                         <p>
                             {t('$BC_link')}
                         </p>
                         <img src={ArrowRight} className="arrow-icon" />
                    </Link>
                </div>
            </div>
            <div className='stat-row'>
                <div className='case-stat-content'>
                    <p className='case-stat-title'>
                        {t('$BC_2')}
                    </p>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '24px', justifyContent: 'space-between', paddingRight: '64px'}}>
                    <label>
                        <p>
                            35% <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 24H38M38 24L24 10M38 24L24 38"
        stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
</svg> 87%
                        </p>
                        {t('$BC_2.1_units')}
                    </label>
                    <label>
                        <p>
                            12
                        </p>
                        {t('$BC_2.2_units')}
                    </label>
                    </div>
                </div>
                <div className='case-stat-descr'>
                    <h1>
                        {t('$BC_2_name')}
                     </h1>
                     <p>
                         {t('$BC_2_disc')}
                     </p>
                     <a>
                        <Link to={`/prod-article`}>
                         <p>
                             {t('$BC_link')}
                         </p>
                         <img src={ArrowRight} className="arrow-icon" />
                         </Link>
                     </a>
                </div>
            </div>
            <div className='stat-row'>
                <div className='case-stat-content'>
                    <p className='case-stat-title'>
                        {t('$BC_3')}
                    </p>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '24px', justifyContent: 'space-between', paddingRight: '64px'}}>
                    <label>
                        <p>
                            11,2
                        </p>
                        {t('$BC_3.1_units')}
                    </label>
                    <label>
                        <p>
                            6-8
                        </p>
                        {t('$BC_3.2_units')}
                    </label>
                    </div>
                </div>
                <div className='case-stat-descr'>
                    <h1>
                        {t('$BC_3_name')}
                     </h1>
                     <p>
                         {t('$BC_3_disc')}
                     </p>
                     <a>
                         <Link to={`/supply-article`}>
                         <p>
                             {t('$BC_link')}
                         </p>
                         <img src={ArrowRight} className="arrow-icon" />
                    </Link>
                     </a>
                </div>
            </div>
            </div>
        </section>
    );
}